import React from 'react';
import PropTypes from 'prop-types';

import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { TextBody } from 'web-ui-components/lib/atoms/text';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { SectionHeading } from 'web-ui-components/lib/molecules/text';
import { isCAUser } from '../../infrastructure/config/selectors';
import { CommonShell } from '../../components/common/CommonShell/CommonShell';

const NoContactNumber = ({ routeTo, content }) => {
  const {
    noNumberHeader,
    noContactPageText1,
    infoCardContent,
    noContactPageText2,
    btnName,
    noContactPageTitle,
    infoCardContentBusinessCustomer,
  } = content;
  return (
    <CommonShell
      backClick={() => {
        routeTo('/exit');
      }}
    >
      <PageHeading>{noContactPageTitle}</PageHeading>
      <SectionHeading heading2={noNumberHeader} />
      <TextBody>
        <p>{noContactPageText1}</p>
      </TextBody>
      <Card className="u-margin-bottom-2" type="info" bordered>
        {isCAUser ? infoCardContentBusinessCustomer : infoCardContent}
      </Card>
      <TextBody>
        <p>{noContactPageText2}</p>
      </TextBody>
      <NavigationButton.Primary
        labelText={btnName}
        onClick={() => {
          routeTo('/exit');
        }}
      />
    </CommonShell>
  );
};

NoContactNumber.propTypes = {
  content: PropTypes.object,
  btnName: PropTypes.func,
  routeTo: PropTypes.func.isRequired,
};

export default NoContactNumber;
